<template>
  <div class="content">
    <div class="instant-risk">
      <div class="instant-risk-wrap">
        <div class="instant-risk-body">
          <div class="instant-risk-icons-list">
            <div v-if="riskTypeCountResultList.length > 0">
              <div class="instant-risk-icons">
                <template v-for="(item, index) in riskTypeCountResultList">
                  <div
                    v-if="index % 2 === 0"
                    class="instant-risk-icon"
                    @click="handleClickRiskType(index)"
                    :key="index"
                  >
                    <img
                      class="icon"
                      :src="
                        require(
                          `@/assets/images/instantRisk/${getColor(riskTypeCountResultList[index].risklevel, index)}@2x.png`,
                        )
                      "
                      alt=""
                    />
                    <div class="text">
                      <div>{{ riskTypeCountResultList[index].num }}</div>
                      <div>{{ riskTypeCountResultList[index].riskname }}</div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="instant-risk-icons right">
                <template v-for="(item, index) in riskTypeCountResultList">
                  <div
                    v-if="!(index % 2 === 0)"
                    class="instant-risk-icon"
                    @click="handleClickRiskType(index)"
                    :key="index"
                  >
                    <img
                      class="icon"
                      :src="
                        require(
                          `@/assets/images/instantRisk/${getColor(riskTypeCountResultList[index].risklevel, index)}@2x.png`,
                        )
                      "
                      alt=""
                    />
                    <div class="text">
                      <div>{{ riskTypeCountResultList[index].num }}</div>
                      <div>{{ riskTypeCountResultList[index].riskname }}</div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="instant-risk-list" v-if="tableList.length > 0">
            <div class="headers">
              <div class="e-header e-header1">位置</div>
              <div class="e-header e-header2">等级</div>
            </div>
            <div class="tables">
              <div
                class="e-column"
                v-for="(item, index) in tableList"
                :key="index"
              >
                <div class="e-data e-data1">{{ item.scope }}</div>
                <div class="e-data e-data2">
                  <div
                    class="level-icon"
                    :style="{
                      'background-color': getLevelColor(item.risklevel),
                    }"
                  ></div>
                  <!-- <div class="level-text">
                    {{ riskLevelMap[item.risklevel] }}
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="instant-risk-info" v-else>当前时间无风险</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import index, { mapState } from "vuex";

export default {
  props: ["params", "forecastType"],
  data() {
    return {
      index: 0,
      riskTypeCountResultList: [],
      tableList: [],
      iconMap: {
        0: "绿",
        4: "蓝",
        3: "黄",
        2: "橙",
        1: "红",
      },
      iconMapColor: {
        0: "#55F28D",
        4: "#53afed",
        3: "#ffcc4d",
        2: "#ffa953",
        1: "#ff6053",
      },
      riskLevelMap: {
        0: "",
        4: "低",
        3: "中",
        2: "较高",
        1: "高",
      },
      init: false,
    };
  },
  watch: {
    newestUnitRisk() {
      this.getData();
    },
    riskTypeCountResult() {
      this.getData();
    },
  },
  computed: {
    ...mapState("home", [
      "objsList",
      "activeCountyId",
      "newestUnitRisk",
      "riskTypeCountResult",
    ]),
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.riskTypeCountResultList = this.riskTypeCountResult;
      this.$nextTick(() => {
        if (!this.init && this.riskTypeCountResultList.length > 0) {
          const maxRiskIndex = this.getMaxRiskTypeCountIndex();
          console.log("maxRiskIndex", maxRiskIndex);
          this.index = maxRiskIndex;
          this.handleClickRiskType(this.index);
          this.init = true;
        }
      });
      console.log("this.riskTypeCountResultList", this.riskTypeCountResultList);
      console.log("this.newestUnitRisk", this.newestUnitRisk);
    },
    getColor(num, index) {
      let color = this.iconMap[num];
      if (index === this.index) {
        color += "-选中";
      }
      return color;
    },
    getMaxRiskTypeCountIndex() {
      this.riskTypeCountResultList = this.riskTypeCountResult;
      const maxIndex = this.riskTypeCountResultList.reduce(
        (maxIndex, item, index, array) => {
          return item.risklevel > array[maxIndex].risklevel ? index : maxIndex;
        },
        0,
      );
      console.log("maxIndex", this.riskTypeCountResultList, maxIndex);
      return maxIndex;
    },
    handleClickRiskType(index) {
      this.index = index;
      const key = this.riskTypeCountResultList[index].riskname;
      // this.riskTypeCountResultList = this.riskTypeCountResult;
      // if (this.riskTypeCountResultList.length <= 0) {
      //   return;
      // }

      // const riskname = this.riskTypeCountResultList[index].riskname;
      // const riskR = this.newestUnitRisk.filter((v) => riskname === v.riskname);
      // console.log("riskR", riskR);
      // if (!riskR || riskR.length === 0) {
      //   this.tableList = [];
      //   return;
      // }
      if (!this.newestUnitRisk[key]) {
        this.tableList = [];
        return;
      }
      this.tableList = this.newestUnitRisk[key];
      console.log("tableList", this.tableList);
    },
    getLevelColor(level) {
      return this.iconMapColor[level];
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 2.6vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  // pointer-events: none;

  .instant-risk {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .instant-risk-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      margin-top: 0.52vw;
      height: calc(100% - 0.52vw);
      overflow: hidden;

      .instant-risk-body {
        display: flex;

        .instant-risk-icons-list {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;

          .right {
            //margin-left: 2rem;
            transform: translate(2rem, -0.6rem);
          }

          .instant-risk-icons {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
          }

          .instant-risk-icon {
            position: relative;
            width: 4.2rem;
            height: 4.2rem;
            display: flex;
            cursor: pointer;
            .icon {
              flex-wrap: wrap;
            }

            .text {
              color: #fff;
              text-align: center;
              position: absolute;
              transform: translate(-50%, -50%);
              left: 45%;
              top: 50%;
              font-size: 0.65vw;
            }
          }
        }

        .instant-risk-info {
          flex: 1;
          display: flex;
          justify-content: center;
          //align-items: center;
          color: #fff;
        }

        .instant-risk-list {
          flex: 1;

          .headers {
            display: flex;
            background: #124577;
            border-radius: 4px;
            text-align: center;
            padding: 5px 10px;
            box-sizing: border-box;

            .e-header {
              color: #ffffff;
              width: 100%;
            }

            .e-header1 {
              flex: 2;
            }

            .e-header2 {
              flex: 1;
            }
          }

          .tables::-webkit-scrollbar {
            width: 0;
          }

          .tables {
            height: 12vh;
            overflow-y: auto;

            .e-column {
              padding: 5px 10px;
              box-sizing: border-box;
              display: flex;
              width: 100%;

              .e-data {
                color: #ffffff;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;

                .level-icon {
                  width: 0.6rem;
                  height: 0.6rem;
                  border-radius: 50%;
                }
              }

              .e-data1 {
                flex: 2;
              }

              .e-data2 {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: 0.8vw;
    color: #fff;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}
</style>
